import type { ReactNode } from 'react'
import { Header } from './Header'
import { Breadcrumb, type BreadcrumbItem } from './Breadcrumb'

interface AppLayoutProps {
  children: ReactNode
  breadcrumbs?: BreadcrumbItem[]
}

export function AppLayout({ children, breadcrumbs }: AppLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6">
          {breadcrumbs && breadcrumbs.length > 0 && (
            <Breadcrumb items={breadcrumbs} className="mb-6" />
          )}
          {children}
        </div>
      </main>
    </div>
  )
}
